import { FilterDropdown } from '../filter-dropdown/filter-dropdown';
import styles from './stats-filters.module.scss';

export type StatsFilterOption = {
	value: string;
	label: string;
};

type StatsFiltersProps = {
	statusValue: string;
	pausedValue: string;
	statusOptions: StatsFilterOption[];
	onFilterChange: (filterType: 'status' | 'paused', value: string) => void;
};

const KNOWN_STATUS_LABELS: Record<string, string> = {
	GOOD: 'Good',
	NEW: 'New',
	NEW_WITH_SALE: 'New with Sale',
	RANDOMTIER1: 'Random Tier 1',
	RANDOMTIER2: 'Random Tier 2',
	RT2_WITH_SALE: 'RT2 with Sale',
	TRASH: 'Trash',
	MEDIUM: 'Medium',
	MODEL1: 'Model 1',
};

const pausedInCacheOptions = [
	{ value: 'Yes', label: 'Yes' },
	{ value: 'No', label: 'No' },
];

export function formatDomainStatusLabel(status: string): string {
	const known = KNOWN_STATUS_LABELS[status];
	if (known) {
		return known;
	}
	return status
		.replace(/_/g, ' ')
		.toLowerCase()
		.replace(/\b\w/g, char => char.toUpperCase());
}

export function toDomainStatusOptions(statuses: string[]): StatsFilterOption[] {
	return statuses.filter(Boolean).map(status => ({
		value: status,
		label: formatDomainStatusLabel(status),
	}));
}

export default function StatsFilters({ statusValue, pausedValue, statusOptions, onFilterChange }: StatsFiltersProps) {
	const handleFilterChange = (filterType: 'status' | 'paused', value: string) => {
		onFilterChange(filterType, value);
	};

	const handleFilterClear = (filterType: 'status' | 'paused') => {
		onFilterChange(filterType, '');
	};

	return (
		<div className={styles.filtersWrapper}>
			<FilterDropdown
				label="State"
				icon="layers-two-01"
				options={statusOptions}
				selectedValue={statusValue}
				onSelect={value => handleFilterChange('status', value)}
				onReset={() => handleFilterClear('status')}
			/>
			<FilterDropdown
				label="Paused"
				icon="pause-circle"
				options={pausedInCacheOptions}
				selectedValue={pausedValue}
				onSelect={value => handleFilterChange('paused', value)}
				onReset={() => handleFilterClear('paused')}
			/>
		</div>
	);
}
